import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UserSidebar from "./UserSidebar";
import UserHeader from "./UserHeader";
import { apiFetch } from "../api_call";
import "./Dashboard.css";

export default function AddDataProtection() {

  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  const [countries, setCountries] = useState([]);
  const [acts, setActs] = useState([]);

  const [country, setCountry] = useState("");
  const [act, setAct] = useState("");

  const [errors, setErrors] = useState({});
  const [errorVisible, setErrorVisible] = useState(false);



  /* =========================
     Error fade-out
  ========================= */
  useEffect(() => {

    if (errors.api) {

      setErrorVisible(true);

      const timer = setTimeout(
        () => setErrorVisible(false),
        4500
      );

      const clearTimer = setTimeout(
        () => setErrors({}),
        5000
      );

      return () => {
        clearTimeout(timer);
        clearTimeout(clearTimer);
      };

    }

  }, [errors.api]);



  /* =========================
     FETCH COUNTRIES
  ========================= */
  useEffect(() => {

    const loadCountries = async () => {

      try {

        // check localStorage first
        const cached = localStorage.getItem("dataComplianceCountries");

        if (cached) {

          setCountries(JSON.parse(cached));
          return;

        }

        const res = await apiFetch("/data-compliance/country");

        if (res.error) {
          setErrors({ api: res.error });
          return;
        }

        setCountries(res.countries || []);

        // store in localStorage
        localStorage.setItem(
          "dataComplianceCountries",
          JSON.stringify(res.countries || [])
        );

      }
      catch (err) {

        setErrors({
          api: "Failed to load countries"
        });

      }

    };

    loadCountries();

  }, []);



  /* =========================
     FETCH ACTS WHEN COUNTRY CHANGES
  ========================= */
  useEffect(() => {

    const loadActs = async () => {

      if (!country) {

        setActs([]);
        setAct("");
        return;

      }

      try {

        const cacheKey = `dataComplianceActs_${country}`;

        const cached = localStorage.getItem(cacheKey);

        if (cached) {

          setActs(JSON.parse(cached));
          setAct("");
          return;

        }

        const res = await apiFetch(
          `/data-compliance/acts?country=${encodeURIComponent(country)}`
        );

        if (res.error) {
          setErrors({ api: res.error });
          return;
        }

        setActs(res.acts || []);

        localStorage.setItem(
          cacheKey,
          JSON.stringify(res.acts || [])
        );

        setAct("");

      }
      catch {

        setErrors({
          api: "Failed to load acts"
        });

      }

    };

    loadActs();

  }, [country]);



  /* =========================
     Submit handler
  ========================= */
  const handleFilter = (e) => {

    e.preventDefault();

    setErrors({});

    if (!country) {

      setErrors({ api: "Country is required" });
      return;

    }

    if (!act) {

      setErrors({ api: "Act is required" });
      return;

    }

    // store selections
    localStorage.setItem("selectedCountry", country);
    localStorage.setItem("selectedAct", act);

    navigate("/data_protection-info");

  };



  return (

    <div className="add-statutory">

      <UserSidebar
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
      />

      <div style={{
        flex: 1,
        display: "flex",
        flexDirection: "column"
      }}>

        <UserHeader
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
        />

        <main style={{
          flex: 1,
          padding: "1rem 2rem",
          overflowY: "auto"
        }}>

          <h2>Add Data Protection</h2>


          {/* ERROR MESSAGE */}
          <div
            className="messages-top"
            style={{
              margin: "0 auto 1rem auto",
              width: "50%",
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
            }}
          >

            {errors.api && (

              <div className={`login-error ${!errorVisible ? "fade-out" : ""}`}>
                {errors.api}
              </div>

            )}

          </div>



          <form
            onSubmit={handleFilter}
            className="add-user-form"
          >


            {/* COUNTRY */}
            <label>

              Select Country

              <select
                value={country}
                onChange={(e) =>
                  setCountry(e.target.value)
                }
              >

                <option value="">
                  Select
                </option>

                {countries.map((c, i) => (

                  <option key={i} value={c}>
                    {c}
                  </option>

                ))}

              </select>

            </label>



            {/* ACT */}
            <label>

              Select Act

              <select
                value={act}
                onChange={(e) =>
                  setAct(e.target.value)
                }
              >

                {acts.length === 0 ? (

                  <option value="">
                    No act found
                  </option>

                ) : (

                  <>
                    <option value="">
                      Select
                    </option>

                    {acts.map((a, i) => (

                      <option key={i} value={a}>
                        {a}
                      </option>

                    ))}

                  </>

                )}

              </select>

            </label>



            {/* BUTTON */}
            <label>

              <button
                type="submit"
                className="submit-btn"
              >
                Filter
              </button>

            </label>


          </form>

        </main>

      </div>

    </div>

  );

}
